export default __webpack_public_path__ + "static/media/Boots of Tribulation.21a804da.jpg";